import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { ZitiDashboardComponent } from '@netfoundry-ui/page/ziti-dashboard';
import { EdgeRouterPoliciesComponent } from '@netfoundry-ui/feature/ziti/edge-router-policies';
import { AzureVirtualWansComponent } from '@netfoundry-ui/page/azurevirtualwans';
import { UserSettingsComponent } from '@netfoundry-ui/page/user-settings';
import { CallbackComponent } from '@netfoundry-ui/page/callback';
import { InvitationComponent } from '@netfoundry-ui/page/invitation';
import { LoginComponent } from '@netfoundry-ui/page/login';
import { LogsComponent } from '@netfoundry-ui/page/logs';
import { MetricsComponent } from '@netfoundry-ui/page/metrics';
import { NetflowCollectorsComponent } from '@netfoundry-ui/page/netflow-collectors';
import { NetworkGroupsComponent } from '@netfoundry-ui/page/network-groups';
import { NetworksCombinedComponent, NetworksListComponent } from '@netfoundry-ui/page/networks-combined';
import { NetworksComponent } from '@netfoundry-ui/page/networks';
import { RolesComponent } from '@netfoundry-ui/page/roles';
import { TestpickboxComponent } from '@netfoundry-ui/page/test-pick-box';
import { UserinfoComponent } from '@netfoundry-ui/page/userinfo';
import { AuthenticationGuard, AuthorizationResolveService, SupportUserGuard } from '@netfoundry-ui/shared/authorization';
import { FeatureService, NETWORK_EXTENSIONS, NetworkExtensionGuard, withBetaListRedirect } from '@netfoundry-ui/shared/services';
import { FrontdoorExtensionGuard } from '@netfoundry-ui/shared/frontdoor-selection';
import { GrowlerErrorHistoryComponent } from '@netfoundry-ui/shared/growler';
import { GettingStartedComponent, SampleServiceComponent } from '@netfoundry-ui/feature/getting-started';
import { AuthPoliciesComponent, PageAuthPoliciesModule } from '@netfoundry-ui/page/auth-policies';
import { ScimComponent, ScimListComponent } from '@netfoundry-ui/page/scim';
import { JwtSignersComponent } from '@netfoundry-ui/page/jwt-signers';
import { ScimIntegrationFormComponent } from '@netfoundry-ui/feature/form/scim/scim-integration-form';
import { ScimIntegrationCreateFormComponent } from '@netfoundry-ui/feature/form/scim/scim-integration-create-form';
import {
  DeactivateGuardService,
  EdgeRoutersPageComponent,
  TransitRoutersPageComponent,
  IdentitiesPageComponent,
  ServicesPageComponent,
  ConfigurationsListPageComponent,
  ConfigurationsPageComponent,
  ConfigurationFormComponent,
  ServicePoliciesPageComponent,
  NetworkVisualizerComponent,
  EdgeRouterPoliciesListPageComponent,
  ServicePoliciesListPageComponent,
  ServicesListPageComponent,
  EdgeRoutersListPageComponent,
  TransitRoutersListPageComponent,
  EdgeRouterPoliciesPageComponent,
  IdentityFormComponent,
  EdgeRouterFormComponent,
  SimpleServiceComponent,
  ServicePolicyFormComponent,
  EdgeRouterPolicyFormComponent,
  ServiceEdgeRouterPoliciesListPageComponent,
  ServiceEdgeRouterPoliciesPageComponent,
  ServiceEdgeRouterPolicyFormComponent,
  TerminatorsListPageComponent,
  TerminatorsPageComponent,
  TerminatorFormComponent,
  JwtSignersListPageComponent,
  JwtSignersPageComponent,
  JwtSignerFormComponent,
  AuthPoliciesListPageComponent,
  AuthPoliciesPageComponent,
  AuthPolicyFormComponent,
  CertificateAuthoritiesListPageComponent,
  CertificateAuthoritiesPageComponent,
  CertificateAuthorityFormComponent,
  VerifyCertificateComponent,
  ConfigTypesListPageComponent,
  ConfigTypesPageComponent,
  ConfigTypeFormComponent,
  PostureChecksListPageComponent,
  PostureChecksPageComponent,
  PostureCheckFormComponent,
  TransitRouterFormComponent,
  SessionsListPageComponent,
  SessionsPageComponent,
  SessionFormComponent,
  APISessionsListPageComponent,
  APISessionsPageComponent,
  APISessionFormComponent,
} from 'ziti-console-lib';

import { CallbackComponent as ZitiCallbackComponent } from 'ziti-console-lib';

import { EdgeRoutersExtensionComponent } from '@netfoundry-ui/page/edge-routers-extension';
import {
    ServiceFormExtensionComponent,
    ServiceCardListComponent,
    CreateServiceFromTemplateComponent,
} from '@netfoundry-ui/page/services-extension';
import {
    ServiceTypeChooserComponent,
    ServicesFromTrafficComponent,
    SourceIdentitiesComponent,
} from '@netfoundry-ui/page/service-create-next';
import { IpsecTunnelerExtensionComponent } from '@netfoundry-ui/page/ipsec-tunneler-extension';
import {
    IdentitiesExtensionComponent,
    IdentitiesListExtensionComponent,
    IdentityConflictDetailsPageComponent,
    IdentityFormExtensionComponent
} from  '@netfoundry-ui/page/identities-extension';
import { OidcAudiencesComponent, OidcAudiencesListComponent } from '@netfoundry-ui/page/oidc-audiences';
import { OidcIdentityAudienceMapComponent, OidcIdentityAudienceMapListComponent } from '@netfoundry-ui/page/oidc-identity-audience-map'
import { OidcIssuersComponent, OidcIssuersListComponent } from '@netfoundry-ui/page/oidc-issuers';
import { OidcOrgPublicClientMapComponent, OidcOrgPublicClientMapListComponent } from '@netfoundry-ui/page/oidc-org-public-client-map';
import { ServicePoliciesExtensionComponent } from '@netfoundry-ui/page/service-policies-extension';
import { ServicePolicyConflictDetailsPageComponent } from '@netfoundry-ui/page/service-policies-extension';
import { ServicePolicyFormExtensionComponent } from '@netfoundry-ui/page/service-policies-extension';

import { environment } from '../environments/environment';
import { FrontendModalComponent } from '@netfoundry-ui/feature/form/frontend-modal';
import {PrivateKeyUploadFormComponent} from "@netfoundry-ui/feature/form/private-key-upload-form";
import { NamespaceFormComponent } from '@netfoundry-ui/feature/form/namespace-form';
import { IpsecTunnelFormComponent } from '@netfoundry-ui/feature/form/ipsec-tunnel-form';
import { IpsecShareFormComponent } from '@netfoundry-ui/feature/form/ipsec-share-form';
import { AuthProviderModalComponent } from '@netfoundry-ui/feature/form/auth-provider-modal';
import {HttpShareFormComponent} from '@netfoundry-ui/feature/form/http-share-form'
import {TcpShareFormComponent} from '@netfoundry-ui/feature/form/tcp-share-form'
import { HealthCheckModalComponent } from '@netfoundry-ui/feature/form/health-check-modal';
import { ClientCertificateFormComponent } from '@netfoundry-ui/feature/form/client-certificate-form';
import { CertificateRequestTokenModalComponent } from '@netfoundry-ui/feature/form/certificate-request-token-modal';
import { AgentModalComponent } from '@netfoundry-ui/feature/form/agent-modal';

const defaultRoutes: Routes = [
    {
        path: 'integrations',
        loadChildren: () => import('@netfoundry-ui/page/subscriptions').then((m) => m.PageSubscriptionsModule),
    },
    { path: 'app-subscriptions', redirectTo: '/integrations/endpoint-lifecycle', pathMatch: 'full' },
    { path: 'virtual-wan', redirectTo: '/integrations/virtual-wan', pathMatch: 'full' },
    { path: 'client-synchronization', redirectTo: '/integrations/aad', pathMatch: 'full' },

    {
        path: 'v7/dashboard',
        redirectTo: '/infrastructure/dashboard',
        pathMatch: 'full',
    },
    {
        path: '',
        redirectTo: '/network/dashboard',
        pathMatch: 'full',
    },
    {
        path: 'main',
        redirectTo: '/network/dashboard',
        pathMatch: 'full',
    },
    { path: 'app-main', redirectTo: '/main', pathMatch: 'full' },

    { path: 'login', component: LoginComponent },
    { path: 'app-login', redirectTo: '/login', pathMatch: 'full' },
    { path: 'vanity-logout', redirectTo: '/login?vanityLogout=true', pathMatch: 'full' },

    {
        path: 'user-identities',
        loadChildren: () => import('@netfoundry-ui/page/identities').then((m) => m.PageIdentitiesModule),
    },
    { path: 'identities/users', redirectTo: '/user-identities/users', pathMatch: 'full' },
    { path: 'identities/user-roles', redirectTo: '/user-identities/user-roles', pathMatch: 'full' },
    { path: 'user-roles', redirectTo: '/user-identities/user-roles', pathMatch: 'full' },
    { path: 'app-users', redirectTo: '/user-identities/app-users', pathMatch: 'full' },
    { path: 'identities/tokens', redirectTo: '/user-identities/tokens', pathMatch: 'full' },
    { path: 'identities/invitations', redirectTo: '/user-identities/invitations', pathMatch: 'full' },

    {
        path: 'reporting',
        loadChildren: () => import('@netfoundry-ui/page/reporting').then((m) => m.PageReportingModule),
    },
    { path: 'dailystats', redirectTo: '/reporting', pathMatch: 'full' },
    { path: 'network-group-summary', redirectTo: '/reporting', pathMatch: 'full' },
    { path: 'daily-endpoint-utilization', redirectTo: '/reporting', pathMatch: 'full' },

    {
        path: 'profile',
        component: UserinfoComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'app-profile', redirectTo: '/profile', pathMatch: 'full' },

    {
        path: 'user-settings',
        component: UserSettingsComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'app-user-settings', redirectTo: '/user-settings', pathMatch: 'full' },
    {
        path: 'oidc-audiences',
        component: OidcAudiencesComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list
        path: 'oidc-audiences/list',
        component: OidcAudiencesListComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'oidc-identity-audience-map',
        component: OidcIdentityAudienceMapComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list
        path: 'oidc-identity-audience-map/list',
        component: OidcIdentityAudienceMapListComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'oidc-issuers',
        component: OidcIssuersComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list
        path: 'oidc-issuers/list',
        component: OidcIssuersListComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'public-client-org-map',
        component: OidcOrgPublicClientMapComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list
        path: 'public-client-org-map/list',
        component: OidcOrgPublicClientMapListComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },

    {
        path: 'logs',
        component: LogsComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'app-logs', redirectTo: '/logs', pathMatch: 'full' },
    {
        path: 'management-events',
        loadChildren: () => import('@netfoundry-ui/page/events').then((m) => m.PageEventsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'fabric-latency',
        loadChildren: () => import('@netfoundry-ui/page/fabric-latency').then((m) => m.PageFabricLatencyModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'controller-latency',
        loadChildren: () => import('@netfoundry-ui/page/controller-latency').then((m) => m.PageControllerLatencyModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'fabric-latency-timeouts',
        loadChildren: () => import('@netfoundry-ui/page/fabric-latency-timeouts').then((m) => m.PageFabricLatencyTimeoutsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'network-events',
        loadChildren: () =>
            import('@netfoundry-ui/page/network-events-metrics-tab').then((m) => m.PageNetworkEventsMetricsTabModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'traffic-analysis',
        canMatch: [() => inject(FeatureService).betaFeaturesEnabled],
        loadChildren: () =>
            import('@netfoundry-ui/page/traffic-analysis-next').then((m) => m.PageTrafficAnalysisNextModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'traffic-analysis',
        loadChildren: () => import('@netfoundry-ui/page/traffic-analysis').then((m) => m.PageTrafficAnalysisModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta Microsegments management surface. New-gen only (no legacy page), so it is gated to beta
        // users and simply does not resolve for everyone else.
        path: 'microsegments',
        canMatch: [() => inject(FeatureService).betaFeaturesEnabled],
        loadChildren: () =>
            import('@netfoundry-ui/page/microsegments-next').then((m) => m.PageMicrosegmentsNextModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    // The list module sits first so its `list` child wins; any other segment falls through to `:id`.
    {
        path: 'network-controllers',
        loadChildren: () =>
            import('@netfoundry-ui/page/network-controllers').then((m) => m.PageNetworkControllersModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'network-controllers/:id',
        loadChildren: () =>
            import('@netfoundry-ui/page/managed-network-controller-detail').then((m) => m.PageManagedNetworkControllerDetailModule),
    },
    {
        path: 'ssh-terminal/:controllerId',
        loadChildren: () =>
            import('@netfoundry-ui/page/ssh-terminal').then((m) => m.PageSshTerminalModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'network/settings',
        loadChildren: () => import('@netfoundry-ui/page/settings').then((m) => m.PageSettingsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'network/operations',
        loadChildren: () => import('@netfoundry-ui/page/operations').then((m) => m.PageOperationsModule),
        canActivate: [AuthenticationGuard, SupportUserGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'allocated-ips',
        loadChildren: () => import('@netfoundry-ui/page/allocated-ips').then((m) => m.PageAllocatedIpsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    // The lazy module goes first so its `list` child wins; any other segment backtracks to `:id`.
    {
        path: 'stored-secrets',
        loadChildren: () => import('@netfoundry-ui/page/stored-secrets').then((m) => m.PageStoredSecretsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'stored-secrets/:id',
      component: PrivateKeyUploadFormComponent,
    },
    {
      path: 'customers',
      loadChildren: () => import('@netfoundry-ui/page/customers').then((m) => m.PageCustomersModule),
      canActivate: [AuthenticationGuard],
      resolve: { authorization: AuthorizationResolveService },
    },

    { path: 'app-events', redirectTo: '/events', pathMatch: 'full' },

    {
        path: 'alarms',
        loadChildren: () => import('@netfoundry-ui/page/alarms').then((m) => m.PageAlarmsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'app-alarms', redirectTo: '/alarms', pathMatch: 'full' },

    { path: 'callback', component: CallbackComponent },

    { path: 'oidc-callback', component: ZitiCallbackComponent },

    { path: 'invitation', component: InvitationComponent },
    { path: 'app-invitation', redirectTo: '/invitation', pathMatch: 'full' },

    {
        path: 'error-history',
        component: GrowlerErrorHistoryComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'page-not-found',
        loadChildren: () => import('@netfoundry-ui/page/page-not-found').then((m) => m.PagePageNotFoundModule),
    },
    {
        path: 'dashboard', redirectTo: '/network/dashboard', pathMatch: 'full'
    },
    {
        path: 'v7/endpoints',
        redirectTo: 'identities',
        pathMatch: 'full',
    },
    {
        path: 'identities',
        component: IdentitiesExtensionComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta identities list, coexisting with the legacy list above. First path segment must stay
        // 'identities' (the lib builds detail links as /<firstSegment>/<id>); must precede 'identities/:id'.
        path: 'identities/list',
        component: IdentitiesListExtensionComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'identities/:id',
        redirectTo: (redirectData) => `/identities/${redirectData.params['id']}/overview`,
        pathMatch: 'full',
    },
    {
        path: 'identities/:id/conflict',
        component: IdentityConflictDetailsPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'identities/:id/:tab',
        component: IdentityFormExtensionComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'jwt-signers/list',
        component: JwtSignersListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'jwt-signers',
        component: JwtSignersPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'jwt-signers/:id',
        component: JwtSignerFormComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'jwt-signers/:id/test-auth',
      component: JwtSignerFormComponent,
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'auth-policies/list',
        component: AuthPoliciesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'auth-policies',
      component: AuthPoliciesPageComponent,
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'auth-policies/:id',
      component: AuthPolicyFormComponent,
      data: { rebuildOnIdChange: true },
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'v7/connections/services',
        redirectTo: 'services',
        pathMatch: 'full',
    },
    {
        path: 'services',
        component: ServicesPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'services/list',
        component: ServicesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'services/simple',
        component: SimpleServiceComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'services/simple/:id',
      component: SimpleServiceComponent,
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta new-gen "Create services from traffic" page: turns a Traffic Analysis selection into one
        // or more services, each configured on its own card. Sits beside the Simple page above.
        path: 'services/create-from-traffic',
        canMatch: [() => inject(FeatureService).betaFeaturesEnabled],
        component: ServicesFromTrafficComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Edit an existing microsegment in the same create-from-traffic screen it was made in: one service
        // card pre-filled from it, saving as an in-place update. Beta only (the page is new-gen).
        path: 'services/create-from-traffic/:id',
        canMatch: [() => inject(FeatureService).betaFeaturesEnabled],
        component: ServicesFromTrafficComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta new-gen "Create identities for sources" step: mints a Ziti identity per source address in
        // the selection, tagged with one shared role attribute the new service grants on its dial policy.
        path: 'services/source-identities',
        canMatch: [() => inject(FeatureService).betaFeaturesEnabled],
        component: SourceIdentitiesComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Only the traffic flow (Traffic Analysis, Microsegments) passes a selection; without it, fall
        // through to the card picker below.
        path: 'services/select',
        canMatch: [
            () => inject(FeatureService).betaFeaturesEnabled,
            () => {
                const queryParams = inject(Router).getCurrentNavigation()?.extractedUrl.queryParams ?? {};
                return !!queryParams['destIp'] || !!queryParams['destPairs'];
            },
        ],
        component: ServiceTypeChooserComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'services/select',
        component: ServiceCardListComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'services/template',
        component: CreateServiceFromTemplateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'services/advanced',
        redirectTo: '/services/advanced/create/overview',
        pathMatch: 'full'
    },
    {
        path: 'services/advanced/:id',
        redirectTo: (redirectData) => `/services/advanced/${redirectData.params['id']}/overview`,
        pathMatch: 'full',
    },
    {
        path: 'services/advanced/:id/:tab',
        component: ServiceFormExtensionComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'v7/routers',
        redirectTo: 'infrastructure/routers',
        pathMatch: 'full',
    },
    {
        path: 'routers',
        component: EdgeRoutersPageComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'routers/list',
        component: EdgeRoutersListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'routers/:id',
        redirectTo: (redirectData) => `/routers/${redirectData.params['id']}/overview`,
        pathMatch: 'full',
    },
    {
        path: 'routers/:id/:tab',
        component: EdgeRoutersExtensionComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'transit-routers/list',
        component: TransitRoutersListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'transit-routers',
        component: TransitRoutersPageComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'transit-routers/list',
        component: TransitRoutersListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'transit-routers/:id',
        component: TransitRouterFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'configs/list',
        component: ConfigurationsListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'configs',
        component: ConfigurationsPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'configs/:id',
        component: ConfigurationFormComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'terminators/list',
        component: TerminatorsListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'terminators',
      component: TerminatorsPageComponent,
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'terminators/:id',
      component: TerminatorFormComponent,
      data: { rebuildOnIdChange: true },
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'v7/connections/appwans',
        redirectTo: 'service-policies',
        pathMatch: 'full',
    },
    {
        path: 'service-policies',
        component: ServicePoliciesExtensionComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'service-policies/list',
        component: ServicePoliciesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'service-policies/:id',
        component: ServicePolicyFormExtensionComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'service-policies/:id/conflict',
        component: ServicePolicyConflictDetailsPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'v7/policies',
        redirectTo: 'router-policies',
        pathMatch: 'full',
    },
    {
        path: 'router-policies',
        component: EdgeRouterPoliciesPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'router-policies/list',
        component: EdgeRouterPoliciesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'router-policies/:id',
        component: EdgeRouterPolicyFormComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'service-router-policies',
        component: ServiceEdgeRouterPoliciesPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'service-router-policies/list',
        component: ServiceEdgeRouterPoliciesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'service-router-policies/:id',
        component: ServiceEdgeRouterPolicyFormComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'posture-checks',
      component: PostureChecksPageComponent,
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'posture-checks/list',
        component: PostureChecksListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
      path: 'posture-checks/:id',
      component: PostureCheckFormComponent,
      data: { rebuildOnIdChange: true },
      canActivate: [AuthenticationGuard],
      canDeactivate: [DeactivateGuardService],
      resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'certificate-authorities/list',
        component: CertificateAuthoritiesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'certificate-authorities',
        component: CertificateAuthoritiesPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'certificate-authorities/:id',
        component: CertificateAuthorityFormComponent,
        data: { rebuildOnIdChange: true },
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'certificate-authorities/:id/verify',
        component: VerifyCertificateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'sessions/list',
        component: SessionsListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'sessions',
        component: SessionsPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'sessions/:id',
        component: SessionFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'api-sessions/list',
        component: APISessionsListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'api-sessions',
        component: APISessionsPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'api-sessions/:id',
        component: APISessionFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede the ':id' route.
        path: 'config-types/list',
        component: ConfigTypesListPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'config-types',
        component: ConfigTypesPageComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'config-types/:id',
        component: ConfigTypeFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing',
        redirectTo: 'billing/dashboard',
        pathMatch: 'full',
    },
    {
        path: 'billing/dashboard',
        pathMatch: 'full',
        loadChildren: () => import('@netfoundry-ui/page/billing').then((m) => m.PageBillingModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/billing',
        pathMatch: 'full',
        loadChildren: () => import('@netfoundry-ui/page/billing').then((m) => m.PageBillingModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/billing',
        loadChildren: () => import('@netfoundry-ui/page/billing').then((m) => m.PageBillingModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'payment-profile',
        loadChildren: () => import('@netfoundry-ui/page/payment-profile').then((m) => m.PagePaymentProfileModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'account-details',
        loadChildren: () => import('@netfoundry-ui/page/account-details').then((m) => m.PageAccountDetailsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing-subscriptions',
        loadChildren: () =>
            import('@netfoundry-ui/page/billing-subscriptions').then((m) => m.PageBillingSubscriptionsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing-subscription-overages',
        loadChildren: () =>
            import('@netfoundry-ui/page/billing-subscription-overages').then(
                (m) => m.PageBillingSubscriptionOveragesModule
            ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing-subscription-invoices',
        loadChildren: () =>
            import('@netfoundry-ui/page/billing-subscription-invoices').then(
                (m) => m.PageBillingSubscriptionInvoicesModule
            ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing-subscription-usage',
        loadChildren: () =>
            import('@netfoundry-ui/page/billing-subscription-usage').then((m) => m.PageBillingSubscriptionUsageModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing-subscription-usage-report',
        loadChildren: () =>
            import('@netfoundry-ui/page/billing-subscription-usage-report').then(
                (m) => m.PageBillingSubscriptionUsageReportModule
            ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/payment-profile',
        loadChildren: () => import('@netfoundry-ui/page/payment-profile').then((m) => m.PagePaymentProfileModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/account-details',
        loadChildren: () => import('@netfoundry-ui/page/account-details').then((m) => m.PageAccountDetailsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/billing-subscriptions',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscriptions').then((m) => m.PageBillingSubscriptionsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/billing-subscription-overages',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-overages').then(
            (m) => m.PageBillingSubscriptionOveragesModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/billing-subscription-invoices',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-invoices').then(
            (m) => m.PageBillingSubscriptionInvoicesModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/billing-subscription-usage',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-usage').then((m) => m.PageBillingSubscriptionUsageModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'billing/billing-subscription-usage-report',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-usage-report').then(
            (m) => m.PageBillingSubscriptionUsageReportModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/payment-profile',
        loadChildren: () => import('@netfoundry-ui/page/payment-profile').then((m) => m.PagePaymentProfileModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/account-details',
        loadChildren: () => import('@netfoundry-ui/page/account-details').then((m) => m.PageAccountDetailsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/billing-subscriptions',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscriptions').then((m) => m.PageBillingSubscriptionsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/billing-subscription-overages',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-overages').then(
            (m) => m.PageBillingSubscriptionOveragesModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/billing-subscription-usage',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-usage').then((m) => m.PageBillingSubscriptionUsageModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organization/billing-subscription-usage-report',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-usage-report').then(
            (m) => m.PageBillingSubscriptionUsageReportModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/payment-profile',
        loadChildren: () => import('@netfoundry-ui/page/payment-profile').then((m) => m.PagePaymentProfileModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/account-details',
        loadChildren: () => import('@netfoundry-ui/page/account-details').then((m) => m.PageAccountDetailsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/billing-subscriptions',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscriptions').then((m) => m.PageBillingSubscriptionsModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/billing-subscription-overages',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-overages').then(
            (m) => m.PageBillingSubscriptionOveragesModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/billing-subscription-usage',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-usage').then((m) => m.PageBillingSubscriptionUsageModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'support/billing-subscription-usage-report',
        loadChildren: () =>
          import('@netfoundry-ui/page/billing-subscription-usage-report').then(
            (m) => m.PageBillingSubscriptionUsageReportModule
          ),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'organizations',
        loadChildren: () => import('@netfoundry-ui/page/organizations').then((m) => m.PageOrganizationsModule),
    },
    { path: 'org-settings', redirectTo: '/organizations/org-settings', pathMatch: 'full' },
    { path: 'settings', redirectTo: '/organizations/org-settings', pathMatch: 'full' },
    { path: 'app-settings', redirectTo: '/organizations/org-settings', pathMatch: 'full' },
    {
        path: 'roles',
        component: RolesComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'notifications',
        loadChildren: () => import('@netfoundry-ui/page/notifications').then((m) => m.PageNotificationsModule),
    },
    {
        path: 'network-groups',
        component: NetworkGroupsComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // No pathMatch: 'full' - the module routes both the legacy list and its beta `list` child.
        path: 'process-executions',
        loadChildren: () => import('@netfoundry-ui/page/process-executions').then((m) => m.PageProcessExecutionsModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // No pathMatch: 'full' - the module routes /alerts and /alerts/mutes, and a full
        // match would refuse to hand the second one over.
        path: 'alerts',
        loadChildren: () => import('@netfoundry-ui/page/alerts').then((m) => m.PageAlertsModule),
        canActivate: [AuthenticationGuard, SupportUserGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'attributes-explorer',
        loadChildren: () =>
            import('@netfoundry-ui/page/attributes-explorer').then((m) => m.PageAttributesExplorerModule),
        pathMatch: 'full',
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'infrastructure/routers', redirectTo: 'network/edge-routers', pathMatch: 'full'
    },
    {
        path: 'network/edge-routers',
        loadChildren: () => import('@netfoundry-ui/page/ziti-edge-routers').then((m) => m.PageZitiEdgeRoutersModule),
    },
    {
        path: 'network/edge-routers/:id',
        loadChildren: () =>
            import('@netfoundry-ui/page/managed-edge-router-detail').then(
                (m) => m.PageManagedEdgeRouterDetailModule
            ),
    },
    {
        path: 'network/ipsec-tunnelers',
        // NetworkExtensionGuard reads the current network's embedded extensions and bounces
        // to /network/dashboard when IPSEC_TUNNELER isn't enabled, so a user who hand-rolls
        // the URL on a non-opted-in network lands somewhere sensible instead of a blank shell.
        // The guard fails open (allows the route through) after a short timeout to avoid
        // hanging on cold reload before the network-fetch chain has populated currentNetwork.
        // The server-side @RequiresNetworkExtension gate still backstops the API regardless.
        canActivate: [NetworkExtensionGuard],
        data: { requiresExtension: NETWORK_EXTENSIONS.IPSEC_TUNNELER },
        loadChildren: () => import('@netfoundry-ui/page/ipsec-tunnelers').then((m) => m.PageIpsecTunnelersModule),
    },
    {
        path: 'network/ipsec-tunnelers/:id',
        component: IpsecTunnelerExtensionComponent,
        canActivate: [AuthenticationGuard, NetworkExtensionGuard],
        canDeactivate: [DeactivateGuardService],
        data: { requiresExtension: NETWORK_EXTENSIONS.IPSEC_TUNNELER },
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'zrouters', redirectTo: 'infrastructure/routers', pathMatch: 'full' },

    {
        path: 'infrastructure/dashboard', redirectTo: 'network/dashboard', pathMatch: 'full'
    },
    {
        path: 'network/dashboard',
        component: ZitiDashboardComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Redesigned dashboard, coexisting with the legacy one above. The sidebar link is
        // experimental-gated; the route itself is open, like /alerts.
        path: 'network/overview',
        loadChildren: () =>
            import('@netfoundry-ui/page/network-overview').then((m) => m.PageNetworkOverviewModule),
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'zdashboard', redirectTo: 'infrastructure/dashboard', pathMatch: 'full' },

    {
        path: 'infrastructure/certificate-authorities',
        loadChildren: () =>
            import('@netfoundry-ui/page/ziti-certificate-authorities').then(
                (m) => m.PageZitiCertificateAuthoritiesModule
            ),
    },
    {
        path: 'self-hosted',
        loadChildren: () => import('@netfoundry-ui/page/on-prem').then((m) => m.PageOnPremModule),
    },
    // The FD sub-app: Frontdoor on the v3 API, beside the v1/v2 routes below.
    // The dashboard is a beta feature, so the sub-app opens on it only where beta is on.
    { path: 'fd', redirectTo: 'fd/dashboard', pathMatch: 'full' },
    { path: 'fd/dashboard',
      loadChildren: () => import('@netfoundry-ui/page/fd-dashboard').then((m) => m.PageFdDashboardModule)},
    /* The share sections are each gated on the selected frontdoor's network carrying their extension, because every
     * endpoint behind them answers 404 without it. The guard fails open, and the server gate is the real one. */
    { path: 'fd/tcp-shares',
      canActivate: [FrontdoorExtensionGuard],
      data: { requiresExtension: NETWORK_EXTENSIONS.TCP_SHARES },
      loadChildren: () => import('@netfoundry-ui/page/fd-tcp-shares').then((m) => m.PageFdTcpSharesModule)},
    { path: 'fd/agents',
      loadChildren: () => import('@netfoundry-ui/page/fd-agents').then((m) => m.PageFdAgentsModule)},
    { path: 'fd/http-shares',
      canActivate: [FrontdoorExtensionGuard],
      data: { requiresExtension: NETWORK_EXTENSIONS.HTTP_SHARES },
      loadChildren: () => import('@netfoundry-ui/page/fd-http-shares').then((m) => m.PageFdHttpSharesModule)},
    { path: 'fd/ipsec',
      canActivate: [FrontdoorExtensionGuard],
      data: { requiresExtension: NETWORK_EXTENSIONS.IPSEC_TUNNELER },
      loadChildren: () => import('@netfoundry-ui/page/fd-ipsec').then((m) => m.PageFdIpsecModule)},
    { path: 'fd/processes',
      loadChildren: () => import('@netfoundry-ui/page/fd-executions').then((m) => m.PageFdExecutionsModule)},
    // The old path of the FD Processes page, kept so bookmarks still land.
    { path: 'fd/executions', redirectTo: '/fd/processes', pathMatch: 'full' },
    { path: 'fd/alerts',
      loadChildren: () => import('@netfoundry-ui/page/fd-alerts').then((m) => m.PageFdAlertsModule)},
    { path: 'fd/audit-events',
      loadChildren: () => import('@netfoundry-ui/page/fd-audit').then((m) => m.PageFdAuditModule)},
    // Support only: the library's routing module guards it with SupportUserGuard.
    { path: 'fd/operations',
      loadChildren: () => import('@netfoundry-ui/page/fd-operations').then((m) => m.PageFdOperationsModule)},
    { path: 'fd/settings',
      loadChildren: () => import('@netfoundry-ui/page/fd-settings').then((m) => m.PageFdSettingsModule)},
    { path: 'frontdoor',
      loadChildren: () => import('@netfoundry-ui/page/frontdoor').then((m) => m.PageFrontdoorModule)},
    { path: 'frontdoor/http-shares',
      loadChildren: () => import('@netfoundry-ui/page/frontdoor-http').then((m) => m.PageFrontdoorHttpModule)},
    { path: 'frontdoor/tcp-shares',
      loadChildren: () => import('@netfoundry-ui/page/frontdoor-tcp').then((m) => m.PageFrontdoorTcpModule)},
    { path: 'frontdoor/frontends',
        loadChildren: () => import('@netfoundry-ui/page/frontends').then((m) => m.PageFrontendsModule)},
    { path: 'frontdoor/namespaces',
        loadChildren: () => import('@netfoundry-ui/page/namespaces').then((m) => m.PageNamespacesModule)},
    { path: 'frontdoor/ipsec-tunnels',
        loadChildren: () => import('@netfoundry-ui/page/ipsec-tunnels').then((m) => m.PageIpsecTunnelsModule)},
    { path: 'frontdoor/ipsec-shares',
        loadChildren: () => import('@netfoundry-ui/page/frontdoor-ipsec').then((m) => m.PageFrontdoorIpsecModule)},
    {
        path: 'frontdoor/ipsec-shares/create',
        component: IpsecShareFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'frontdoor/ipsec-shares/:id',
        component: IpsecShareFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'frontdoor/ipsec-tunnels/create',
        component: IpsecTunnelFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'frontdoor/ipsec-tunnels/:id',
        component: IpsecTunnelFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'frontdoor/namespaces/create',
        component: NamespaceFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'frontdoor/authentication-providers/create',
        component: AuthProviderModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/authentication-providers/:id',
        component: AuthProviderModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/namespaces/:id',
        component: NamespaceFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/http-shares/create',
        component: HttpShareFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/certificate-request-tokens/:id',
        component: CertificateRequestTokenModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
            {
        path: 'frontdoor/client-certificate-request-tokens/create',
        component: CertificateRequestTokenModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/client-certificates/:id',
        component: ClientCertificateFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
            {
        path: 'frontdoor/client-certificates/create',
        component: ClientCertificateFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/http-shares/:id',
        component: HttpShareFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
            {
        path: 'frontdoor/health-checks/create',
        component: HealthCheckModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/health-checks/:id',
        component: HealthCheckModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/tcp-shares/create',
        component: TcpShareFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
        {
        path: 'frontdoor/tcp-shares/:id',
        component: TcpShareFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'frontdoor/agents/enroll',
        component: AgentModalComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'frontdoor/agents',
        loadChildren: () => import('@netfoundry-ui/page/agents').then((m) => m.PageAgentsModule)
    },
    { path: 'frontdoor/authentication',
        loadChildren: () => import('@netfoundry-ui/page/frontdoor-providers').then((m) => m.PageFrontdoorProvidersModule)
    },
    { path: 'frontdoor/client-certificates',
        loadChildren: () => import('@netfoundry-ui/page/client-certificates').then((m) => m.PageClientCertificatesModule)
    },
    { path: 'frontdoor/agents/:zId',
        loadChildren: () => import('@netfoundry-ui/page/agent-by-id').then((m) => m.PageAgentByIdModule)},
    { path: 'frontdoor/frontends/:id',
        loadChildren: () => import('@netfoundry-ui/page/frontend-by-id').then((m) => m.PageFrontendByIdModule)},
    { path: 'frontdoor/metrics',
        loadChildren: () => import('@netfoundry-ui/page/frontdoor-metrics').then((m) => m.PageFrontdoorMetricsModule)
    },
    { path: 'frontdoor/health-checks',
        loadChildren: () => import('@netfoundry-ui/page/health-checks').then((m) => m.PageHealthChecksModule)
    },
    { path: 'frontdoor/certificate-request-tokens',
        loadChildren: () => import('@netfoundry-ui/page/certificate-request-tokens').then((m) => m.PageCertificateRequestTokensModule)
    },
    { path: 'frontdoor/create',
        loadChildren: () => import('@netfoundry-ui/page/frontdoor-config').then((m) => m.PageFrontdoorConfigModule)},
    { path: 'frontdoor/certificate-upload',
        loadChildren: () => import('@netfoundry-ui/page/client-certificate-csr').then((m) => m.PageClientCertificateCsrModule),
        data: { skipAuth: true }},
    { path: 'frontdoor/v2/certificate-upload',
        loadChildren: () => import('@netfoundry-ui/page/client-certificate-csr').then((m) => m.PageClientCertificateCsrModule),
        data: { skipAuth: true }},
    // The v3 upload page, reached from a share link carrying an enrollment JWT in its fragment.
    { path: 'frontdoor/v3/certificate-upload',
        loadChildren: () => import('@netfoundry-ui/page/client-certificate-csr').then((m) => m.PageClientCertificateCsrModule),
        data: { skipAuth: true }},
    // The public renewal page that the certificate-expiring email links to.
    { path: 'frontdoor/certificate-renew',
        loadChildren: () => import('@netfoundry-ui/page/client-certificate-csr').then((m) => m.PageClientCertificateRenewModule),
        data: { skipAuth: true }},
    { path: 'frontdoor/:name',
        loadChildren: () => import('@netfoundry-ui/page/frontdoor-config').then((m) => m.PageFrontdoorConfigModule)},

    {
       path: 'support-operations',
       loadChildren: () => import('@netfoundry-ui/page/support-operations').then((m) => m.PageSupportOperationsModule),
       canActivate: [AuthenticationGuard, SupportUserGuard],
    },
    { path: 'infrastructure/network-groups', redirectTo: 'network-groups', pathMatch: 'full' },
    {
        path: 'networks',
        component: NetworksCombinedComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list
        path: 'networks/list',
        component: NetworksListComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'networks-combined', redirectTo: 'networks', pathMatch: 'full' },
    { path: 'infrastructure/networks', redirectTo: 'networks', pathMatch: 'full' },
    {
        path: 'network-visualizer',
        component: NetworkVisualizerComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'v7/topology',
        loadChildren: () => import('@netfoundry-ui/page/topology').then((m) => m.PageTopologyModule),
    },
    { path: 'topology', redirectTo: 'v7/topology', pathMatch: 'full' },

    {
        path: 'infrastructure/metrics',
        component: MetricsComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    { path: 'metrics', redirectTo: 'infrastructure/metrics', pathMatch: 'full' },
    { path: 'v7/metrics', redirectTo: 'infrastructure/metrics', pathMatch: 'full' },
    {
        path: 'getting-started',
        component: GettingStartedComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'getting-started/sample-service',
        component: SampleServiceComponent,
        canActivate: [AuthenticationGuard],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'integrations/scim',
        component: ScimComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        // Beta list; must precede ':id'.
        path: 'integrations/scim/list',
        component: ScimListComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'integrations/scim/create',
        component: ScimIntegrationCreateFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'integrations/scim/:id',
        component: ScimIntegrationFormComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [DeactivateGuardService],
        resolve: { authorization: AuthorizationResolveService },
    },
    {
        path: 'service-templates',
        loadChildren: () =>
            import('@netfoundry-ui/page/ziti-service-templates').then((m) => m.PageZitiServiceTemplatesModule),
    },
    // NOTE: any new route must be added before this route page not found route
    { path: '**', redirectTo: 'page-not-found', resolve: { authorization: AuthorizationResolveService } },
];
//if lower only, add to the array, don't define separate array

export const routes: Routes = withBetaListRedirect(defaultRoutes);

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    providers: [AuthenticationGuard, AuthorizationResolveService],
})
export class AppRoutingModule {}
